(function (root) {
  'use strict';
  // Use merchandise amounts, not a checkout/update total that can include shipping.
  function merchandiseSubtotal(cart) {
    if (!cart) return NaN;
    if (Number.isFinite(cart.items_subtotal_price)) {
      const orderDiscount = (cart.cart_level_discount_applications || []).reduce((sum, entry) => {
        const amount = Number(entry.total_allocated_amount ?? entry.amount ?? entry.discount_application?.total_allocated_amount ?? 0);
        return sum + (Number.isFinite(amount) ? Math.max(0, amount) : 0);
      }, 0);
      return Math.max(0, cart.items_subtotal_price - orderDiscount);
    }
    return Number(cart.total_price);
  }
  function shippingState(cart, config, estimate) {
    const threshold = config.thresholdCents;
    const currency = cart && cart.currency || config.cartCurrency;
    const eligible = Array.isArray(config.countries) && config.countries.includes(config.country);
    if (!cart || currency !== config.currency || !eligible || !Number.isInteger(threshold) || threshold <= 0) {
      return { kind: 'unknown' };
    }
    const actual = merchandiseSubtotal(cart);
    if (!Number.isFinite(actual) || actual < 0) return { kind: 'unknown' };
    if (!cart.item_count) return { kind: 'empty', remaining: threshold, amount: 0 };
    const estimated = Number.isFinite(estimate) && estimate < actual;
    const amount = Math.max(0, Math.round(estimated ? estimate : actual));
    return { kind: amount >= threshold ? 'qualified' : 'below', amount, remaining: Math.max(0, threshold - amount), estimated };
  }
  function update(cart, estimate) {
    const config = root.LM_SHIPPING || {};
    const state = shippingState(cart, config, estimate);
    const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: config.currency || 'USD' }).format(cents / 100);
    root.document.querySelectorAll('[data-shipping-progress]').forEach(el => {
      const message = el.querySelector('[data-shipping-message]');
      const meter = el.querySelector('[data-shipping-meter]');
      const prefix = state.estimated ? 'Est. ' : '';
      el.dataset.shippingState = state.kind;
      el.hidden = state.kind === 'empty';
      meter.hidden = state.kind === 'unknown' || state.kind === 'empty';
      meter.max = config.thresholdCents || 5000;
      meter.value = Math.min(state.amount || 0, meter.max);
      if (state.kind === 'unknown') {
        message.textContent = 'Shipping at checkout';
      } else if (state.kind === 'empty') {
        message.textContent = 'Free shipping $50+';
      } else if (state.kind === 'qualified') {
        message.textContent = prefix + 'Free shipping';
      } else {
        message.textContent = prefix + 'Add ' + money(state.remaining) + ' for free shipping';
      }
      meter.setAttribute('aria-valuetext', state.kind === 'below' ? money(state.remaining) + ' more for free standard shipping' : message.textContent);
    });
    return state;
  }
  root.LMShipping = { shippingState, merchandiseSubtotal, update };
  if (typeof module !== 'undefined') module.exports = { shippingState, merchandiseSubtotal };
})(typeof window !== 'undefined' ? window : globalThis);
